export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-gerenciamento-diario' */ '@/views/ambulatorio/gerenciamento-diario/Index'),
        path: 'gerenciamento-diario',
        redirect: 'gerenciamento-diario/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-gerenciamento-diario' */'@/views/ambulatorio/gerenciamento-diario/List.vue'),
                name: 'ambulatorio-gerenciamento-diario-index',
                path: 'index',
            },
        ],
    },
]